import * as React from "react";
import {
  WidgetFrame,
  ProgressWidget,
  ErrataWidget,
  FormJSON,
} from "../../../personal-studio-components/studio";
import { Table } from "../../../personal-studio-components/table";
import { Dialog } from "../../../personal-studio-components/component/Dialog.jsx";
// eslint-disable-next-line no-unused-vars
import { BringFriendModel } from "./BringFriendModel.js";
//import * as cls from "./BringFriend.module.scss";
export { BringFriendView };
/**
 * Вид страницы "Акции / Пригласить друга".
 * @param {Object} props - Атрибуты компонента.
 * @param {BringFriendModel} props.model - Модель страницы.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function BringFriendView({ model }) {
  const menu = model.getMenu();
  const schema = model.getSchema();
  return (
    <WidgetFrame icon={model.icon} title={model.title} menu={menu}>
      <p dangerouslySetInnerHTML={{ __html: model.text }}></p>
      <Table {...model.table} />
      <Dialog title={schema.title} open={model.open} onClose={model.onClick}>
        <FormJSON layout="grid" schema={schema} />
      </Dialog>
    </WidgetFrame>
  );
}
/**
 * Вид загрузчика страницы.
 * @param {Object} props - Атрибуты компонента.
 * @param {string} props.title - Заголовок страницы.
 * @returns {JSX.Element} Элемент JSX.
 */
BringFriendView.LoaderView = ProgressWidget;
/**
 * Вид отчёта об ошибке загрузки страницы.
 * @param {Object} props - Атрибуты компонента.
 * @param {Errata} props.errata - Отчёт об ошибке.
 * @returns {JSX.Element} Элемент JSX.
 */
BringFriendView.ErrataView = ErrataWidget;

